export default __webpack_public_path__ + "static/media/blueKalenday.8ac2b3ed.png";